import React, {useState,useEffect} from 'react';
import {Grid,} from '@material-ui/core'

import {DashboardHeader} from '../../../components'
import './style.scss'
import DataTable from '../../../components/dataTable/servicesSelectionDatatable'
import { harvestHeadCells} from './constant'
import HttpService from "../../../services/http.service";
import {getUserDataFromLocalStorage} from "../../../services/utils";
function MyHarvest(props) {
     const [loading, setLoading] = useState(true)
  const [product, setProduct] = useState([])
  let loginUser = getUserDataFromLocalStorage()
  useEffect(() => {
    setLoading(true)
    HttpService.get('products/getMyProducts?ssoId='+loginUser.ssoId).then(res => {
      if (res) {
        setProduct(res.data)
        setLoading(false)
      }
    });
  }, []);
  return (
    <Grid container direction={'column'} className='p-20 content-main-container'>
      <DashboardHeader pageTitle={'My harvest'} addNewItem={'add new harvest'}/>
      <div className="mt-20">
        {
          // (loading) ? <Loader/> :
          //   (usersList && usersList.resp.length > 0) ?
          !loading > 0 && <DataTable
            // data={{rows: usersList?.resp, column: headCells,}}
            // data={{rows: data, column: servicesHeadCells,}}
            data={{
              // rows:activeCat==='vendor'? vendorsData:servicesData ,
              rows: product,
              // column:activeCat==='vendor'? vendorsHeadCells:servicesHeadCells,
              column: harvestHeadCells,
            }}
            // vendor={activeCat==='vendor'}
            tableName={'harvest'}
            // loading={loading}
            // pagination={{
            //   totalRows: usersList?.pagination?.rowCount,
            //   pageSize: pageSize,
            //   onPageSizeChange: onPageSizeChange,
            //   pageNo: pageNo - 1,
            //   onPageChange: onPageChange
            // }}
          />
          // :
          //     (usersList && !usersList.resp.length > 0 && !loading) ? <NoData text={"no data available"}/>
          //       : <Loader/>
        }
      </div>

    </Grid>
  );
}

export default MyHarvest;
